
const getRechargeCookie = (name) => {
  return (document.cookie.match('(^|; )' + name + '=([^;]*)')||0)[2];
};

const getGALinkerParam = () => {
  try {
    // Cross-domain tracking with Google Analytics
    const param = ga.getAll()[0].get('linkerParam');
    return `&${param}`;
  } catch (e) {
    // 'ga' is not available
    return '';
  }
};

export const getRechargeURL = (domain, customerId, customerEmail, discountCode) => {
  // Recharge checkout deprecated Oct 2024 - now using Shopify native checkout
  // Keeping function for backward compatibility but returning Shopify checkout
  const discountParam = (discountCode) ? `?discount=${discountCode}` : '';
  
  // Log for debugging if still being called
  console.warn('getRechargeURL called but using Shopify checkout - Recharge checkout deprecated');
  
  return `/checkout${discountParam}`;
};
